module.exports = __webpack_public_path__ + "img/roulette-marker.147da1b2.svg";